import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerifyCustomerGovIdComponent } from './verify-customer-gov-id.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { CustomerGovIdBadgeModule } from '../../customer/customer-gov-id-badge/customer-gov-id-badge.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [VerifyCustomerGovIdComponent],
  exports: [VerifyCustomerGovIdComponent],
  imports: [
    CommonModule,
    MatCheckboxModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    CustomerGovIdBadgeModule,
    MatSlideToggleModule,
  ],
})
export class VerifyCustomerGovIdModule {}
